exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audit-trail-wrapper {\n  position: relative;\n  /* Safari */\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n@media (max-width: 767px) {\n  .audit-trail-wrapper {\n    display: block;\n    height: auto;\n  }\n}\n.audit-trail-items {\n  padding: 0 30px;\n  width: 100%;\n}\n.audit-trail-download {\n  padding: 0 30px;\n  width: 100%;\n}\nh1 {\n  margin-left: 0;\n}\n.auditTrailDateRange div {\n  width: 25%;\n  display: inline-block;\n}\n.auditTrailDateRange button {\n  display: inline;\n}\n.auditTrailDateRangeWrapper {\n  padding-top: 10px;\n  border-top: 1px #DDDDDD solid;\n  margin-bottom: 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/audit-trail/audit-trail.component.less
// module id = ../../../../../src/app/audit-trail/audit-trail.component.less
// module chunks = 1